import React from 'react';
import UserDashboardLayout from '../dashboard/UserDashboardLayout';

interface DevLayoutProps {
    children: React.ReactNode;
}

const DevLayout: React.FC<DevLayoutProps> = ({ children }) => {
    return (
        <UserDashboardLayout>
            {children}
        </UserDashboardLayout>
    );
};

export default DevLayout;
